export enum EActionTypes {
  ADD_SPECIALIST = 'pickedSpecialists/add',
  REMOVE_SPECIALIST = 'pickedSpecialists/remove',
}
